import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center transition-colors focus-visible:outline-none focus-visible:ring-gray-1000 focus-visible:ring-1 focus-visible:ring-offset-1 disabled:text-gray-400 disabled:pointer-events-none",
  {
    variants: {
      variant: {
        fill: "disabled:bg-gray-100",
        outline: "border disabled:border-gray-200",
        ghost: "border-none bg-transparent",
      },
      size: {
        small: "text-label3 rounded-4 p-2 h-8",
        medium: "text-label2 rounded-6 p-3 h-10",
        large: "text-label1 rounded-8 p-4 h-12",
      },
      color: {
        primary: "",
        "primary-low": "",
        secondary: "",
        danger: "",
        info: "",
      },
      hasPrefixIcon: {
        true: "",
        false: "",
      },
      hasSuffixIcon: {
        true: "",
        false: "",
      },
    },
    compoundVariants: [
      {
        variant: "fill",
        color: "primary",
        class: "bg-primary-500 text-gray-10 hover:bg-primary-700 active:bg-primary-900",
      },
      {
        variant: "fill",
        color: "primary-low",
        class: "bg-primary-10 text-primary-500 hover:bg-primary-100 active:bg-primary-300",
      },
      {
        variant: "fill",
        color: "secondary",
        class: "bg-gray-100 text-gray-1000 hover:bg-gray-200 active:bg-gray-400",
      },
      {
        variant: "fill",
        color: "danger",
        class: "bg-red-500 text-gray-10 hover:bg-red-600 active:bg-red-800",
      },
      {
        variant: "fill",
        color: "info",
        class: "bg-blue-500 text-gray-10 hover:bg-blue-600 active:bg-blue-700",
      },
      {
        variant: "outline",
        color: "primary",
        class: "border-primary-500 text-primary-500 hover:bg-primary-10 active:bg-primary-200",
      },
      {
        variant: "outline",
        color: "primary-low",
        class: "border-primary-400 text-primary-500 hover:bg-primary-10 active:bg-primary-100",
      },
      {
        variant: "outline",
        color: "secondary",
        class: "border-gray-500 text-gray-1000 hover:bg-gray-10 active:bg-gray-100",
      },
      {
        variant: "outline",
        color: "danger",
        class: "border-red-500 text-red-500 hover:bg-red-10 active:bg-red-100",
      },
      {
        variant: "outline",
        color: "info",
        class: "border-blue-500 text-blue-500 hover:bg-blue-10 active:bg-blue-100",
      },
      {
        variant: "ghost",
        color: "primary",
        class: "text-primary-500 hover:bg-primary-10 active:bg-primary-200",
      },
      {
        variant: "ghost",
        color: "primary-low",
        class: "text-primary-500 hover:bg-primary-10 active:bg-primary-100",
      },
      {
        variant: "ghost",
        color: "secondary",
        class: "text-gray-1000 hover:bg-gray-10 active:bg-gray-100",
      },
      {
        variant: "ghost",
        color: "danger",
        class: "text-red-500 hover:bg-red-10 active:bg-red-100",
      },
      {
        variant: "ghost",
        color: "info",
        class: "text-blue-500 hover:bg-blue-10 active:bg-blue-100",
      },
      {
        size: "small",
        hasPrefixIcon: true,
        hasSuffixIcon: false,
        class: "pl-[6px]",
      },
      {
        size: "small",
        hasPrefixIcon: false,
        hasSuffixIcon: true,
        class: "pr-[6px]",
      },
      {
        size: "small",
        hasPrefixIcon: true,
        hasSuffixIcon: true,
        class: "px-2",
      },
      {
        size: "medium",
        hasPrefixIcon: true,
        hasSuffixIcon: false,
        class: "pl-2",
      },
      {
        size: "medium",
        hasPrefixIcon: false,
        hasSuffixIcon: true,
        class: "pr-2",
      },
      {
        size: "medium",
        hasPrefixIcon: true,
        hasSuffixIcon: true,
        class: "px-3",
      },
      {
        size: "large",
        hasPrefixIcon: true,
        hasSuffixIcon: false,
        class: "pl-3",
      },
      {
        size: "large",
        hasPrefixIcon: false,
        hasSuffixIcon: true,
        class: "pr-3",
      },
      {
        size: "large",
        hasPrefixIcon: true,
        hasSuffixIcon: true,
        class: "px-4",
      },
    ],
    defaultVariants: {
      variant: "fill",
      size: "medium",
      color: "primary",
      hasPrefixIcon: false,
      hasSuffixIcon: false,
    },
  },
);
